import { Text, View } from '@react-pdf/renderer'
import colors from 'constants/colors'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { IItemVisibility, ILayout } from 'types/layoutInterfaces'
import { useStyles } from './styles'

interface IAboutProps {
  description: string
  layout: ILayout
  headingColor: string
}

/**
 * Renders the About component.
 *
 * @param {string} description - The description of the component.
 * @param {object} layout - The layout configuration object.
 * @param {string} headingColor - The color of the heading.
 * @return {React.ReactElement} The rendered About component.
 * @notExported
 */
const About: React.FC<IAboutProps> = ({ description, layout, headingColor }) => {
  const { t } = useTranslation()
  const styles = useStyles()

  const hidden = useMemo(() => {
    if (layout && layout.ItemVisibilities && layout.ItemVisibilities.length > 0) {
      const visibilities = layout.ItemVisibilities.filter((visibility: IItemVisibility) => visibility.type === 'about')
      if (visibilities.length > 0) {
        return visibilities.every((value: IItemVisibility) => value.hidden === true)
      }
    }
  }, [layout])

  if (hidden) {
    return <></>
  } else {
    return (
      <>
        <View style={styles.container}>
          <Text style={[styles.title, { color: headingColor ? headingColor : colors.secondary }]}>
            {t('print.about.title')}
          </Text>
          <Text style={styles.description}>{description}</Text>
        </View>
      </>
    )
  }
}

export default About
